export const CUSTOMER_DOCUMENT_DROP_DOWN_ITEMS = []